import React from 'react';
import { sanitizeHtml } from '../lib/sanitizeHtml';

/**
 * Safely renders HTML content by:
 * 1. Detecting if content is HTML
 * 2. Sanitizing with DOMPurify (safe tags, no event handlers, safe URIs)
 * 3. Rendering with dangerouslySetInnerHTML (React's way to render HTML)
 */
const SafeHtml = ({ content, className = '' }) => {
    if (!content) return null;

    // Simple check if content contains HTML tags
    const hasHtml = /<[a-z][\s\S]*>/i.test(content);

    if (!hasHtml) {
        // Plain text - render with whitespace preservation
        return (
            <div className={`whitespace-pre-wrap ${className}`}>
                {content}
            </div>
        );
    }

    const sanitized = sanitizeHtml(content);

    // Check if this is for a dark background (outbound email)
    const isDark = className.includes('text-white');

    return (
        <div
            className={`prose prose-sm max-w-none ${className}`}
            dangerouslySetInnerHTML={{ __html: sanitized }}
            style={{
                // Ensure links are visible and styled
                '--tw-prose-links': isDark ? 'rgb(147, 197, 253)' : 'rgb(59, 130, 246)',
                '--tw-prose-body': isDark ? 'rgb(255, 255, 255)' : 'rgb(51, 65, 85)',
                '--tw-prose-headings': isDark ? 'rgb(255, 255, 255)' : 'rgb(15, 23, 42)',
                // Ensure images don't overflow
                '--tw-prose-img': 'max-width: 100%; height: auto;',
                // Override prose styles for dark backgrounds
                color: isDark ? 'rgb(255, 255, 255)' : undefined,
            }}
        />
    );
};

export default SafeHtml;

